import { Injectable, Signal, inject, signal } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpParams, HttpClient, HttpBackend } from '@angular/common/http';
import { PortalMenuService } from '../menu-service/portal-menu.service';

@Injectable({
  providedIn: 'root',
})
export class AuthorizationService {
  private http = inject(HttpClient);
  private handler = inject(HttpBackend);
  private httpClient = inject(HttpClient);
  private menuService = inject(PortalMenuService);

  profileName: string;
  userNameUrl = 'api/GetJWT?code=';
  userCode: any;
  partnerName: any;
  ssoPartner = localStorage.getItem('ssoPartner');
  selectedPartner = localStorage.getItem('partnerName');
  selectedDashboardId: any;
  quickSightUrl: any;
  userEmail: any;
  email: string;
  tokenExpirationTime: string;
  dashBoardUrl = 'api/GetDashboardEmbedURL?dashboardId=';
  isLoggedIn = false;
  rawToken: any;
  impersonatedPartner: string;
  reLoginDialogLoaded = false;
  userRoleList: any;
  loadDashboard = signal(false);
  constructor() {
    this.httpClient = new HttpClient(this.handler);
  }
  public getUserValues(): Observable<any> {
    if (this.userCode) {
      return this.httpClient.get(
        this.userNameUrl + this.userCode + '&partner=' + this.ssoPartner
      );
    } else {
      this.userCode = localStorage.getItem('code');
      return this.httpClient.get(
        this.userNameUrl + this.userCode + '&partner=' + this.ssoPartner
      );
    }
  }

  public updateToken(): Observable<any> {
    return this.http.get('api/RefreshToken');
  }

  public checkPortalMessage(partnerName): Observable<any> {
    return this.http.post('api/checkPortalMessage', partnerName);
  }

  public getPortalMessage(partnerName): Observable<any> {
    return this.http.post('api/getPortalMessages', partnerName);
  }

  public setDisabledUser(id, status): Observable<any> {
    return this.http.get('api/setDisabledUser?id=' + id + '&status=' + status);
  }

  public setPortalMessage(
    messageID,
    startTime,
    endTime,
    message,
    enabledPartners
  ): Observable<any> {
    let params = new HttpParams();

    if (messageID) {
      params = params.set('id', messageID);
    }
    return this.http.post(
      'api/setPortalMessage',
      {
        startTime,
        endTime,
        message,
        enabledPartners,
      },
      {
        params,
        observe: 'response',
        responseType: 'text',
      }
    );
  }

  public deletePortalMessage(message): Observable<any> {
    return this.http.post('api/deletePortalMessages', message);
  }

  getDashUrl(dashboardID: any) {
    const partnerName = localStorage.getItem('partnerName');
    if (this.selectedPartner) {
      this.impersonatedPartner = this.selectedPartner;
    } else {
      this.impersonatedPartner = this.partnerName;
    }
    return this.http.get(
      this.dashBoardUrl +
        dashboardID +
        '&partner=' +
        partnerName +
        '&impersonatedPartner=' +
        this.impersonatedPartner
    );
  }
  public getDashboardState(dashboardId): Observable<any> {
    if (this.selectedPartner) {
      this.impersonatedPartner = this.selectedPartner;
    } else {
      this.impersonatedPartner = this.partnerName;
    }
    return this.http.get(
      'api/getDashboardState?dashboardId=' +
        dashboardId +
        '&impersonatedPartner=' +
        this.impersonatedPartner,
      {
        observe: 'response',
        responseType: 'text',
      }
    );
  }

  getPartnerMenu() {
    this.menuService.setMenuData(this.partnerName);
  }
}
